import styled from 'styled-components';

// iOS HACK to add spacing to the bottom of the form.
// Needed because the keyboard was covering the form inputs
// Maybe we could trigger this only if the user is on iOS
export const MobileSpacer = styled.div`
  ${Styles.mobile`
    height: 50vh;
  `}
`;
